const productsName = {
    blade_rlm: '/products/blade-robotic-lawn-mower',
    glacier_prr2pps: '/products/glacier-portable-refrigerator-river-2-pro-portable-power-station',
    glacier_prdmpps: '/products/glacier-portable-refrigerator-delta-max-portable-power-station',
    wave2_pacd2pps: '/products/wave-2-portable-air-conditioner-delta-2-portable-power-station',
    wave2_pacdmpps: '/products/wave-2-portable-air-conditioner-delta-max-portable-power-station',
    wave2_pacdppps: '/products/wave-2-portable-air-conditioner-delta-pro-portable-power-station',
    glacierEB: '/products/glacier-portable-refrigerator',
    glacierEB110w: '/products/glacier-portable-refrigerator',
    wave2EB: '/products/wave-2-portable-air-conditioner',
    wave2EB160w: '/products/wave-2-portable-air-conditioner',
};

export const bundleKey = {
    wave2delta2: 'wave2delta2',
    wave2deltamax: 'wave2deltamax',
    wave2deltapro: 'wave2deltapro',
    glacierriver2pro: 'glacierriver2pro',
    glacierdeltamax: 'glacierdeltamax',
    glacierriversolar: 'glacierriversolar',
    bladelsk: 'bladelsk',
    blade_seb_400psp: 'blade_seb_400psp',
    blade_lsk_seb_400psp: 'blade_lsk_seb_400psp',
    glacierEB: 'glacierEB',
    glacierEB110w: 'glacierEB110w',
    wave2EB: 'wave2EB',
    wave2EB160w: 'wave2EB160w',
    d2m220: 'd2m220',
    d2m400: 'd2m400',
    d2mWave2: 'd2mWave2',
    d2mEB: 'd2mEB',
    d2mWave2_au: 'd2mWave2_au',
    d2mEC: 'd2mEC',
    d2mPS: 'd2mPS',
    glacierriver2max: 'glacierriver2max',
    wave2glacier: 'wave2glacier',
    r2110: 'r2110',
    d2220: 'd2220',
    dp400: 'dp400',
    glacierdelta2: 'glacierdelta2',
    glacierriver2pro220w: 'glacierriver2pro220w',
    river2max: 'river2max',
    river2pro: 'river2pro',
    delta2: 'delta2',
};

export const bundleLink = {
    [bundleKey.bladelsk]: {
        us: `https://us.ecoflow.com${productsName.blade_rlm}?variant=40518791168073`,
        ca: `https://ca.ecoflow.com${productsName.blade_rlm}?variant=43510266134682`,
        eu: `https://eu.ecoflow.com${productsName.blade_rlm}?variant=46491585151319`,
        uk: `https://uk.ecoflow.com${productsName.blade_rlm}?variant=46526037590355`,
        de: `https://de.ecoflow.com${productsName.blade_rlm}?variant=46538133864783`,
        fr: `https://fr.ecoflow.com${productsName.blade_rlm}?variant=46505479864667`,
        it: `https://it.ecoflow.com${productsName.blade_rlm}?variant=46532250501469`,
        es: `https://es.ecoflow.com${productsName.blade_rlm}?variant=46505471246683`,
    },
    [bundleKey.blade_lsk_seb_400psp]: {
        us: `https://us.ecoflow.com${productsName.blade_rlm}?variant=40521236021321`,
        ca: `https://ca.ecoflow.com${productsName.blade_rlm}?variant=43510266167450`,
        eu: `https://eu.ecoflow.com${productsName.blade_rlm}?variant=46491585184087`,
        uk: `https://uk.ecoflow.com${productsName.blade_rlm}?variant=46526037623123`,
        de: `https://de.ecoflow.com${productsName.blade_rlm}?variant=46538133897551`,
        fr: `https://fr.ecoflow.com${productsName.blade_rlm}?variant=46505479897435`,
        it: `https://it.ecoflow.com${productsName.blade_rlm}?variant=46532250534237`,
        es: `https://es.ecoflow.com${productsName.blade_rlm}?variant=46505471279451`,
    },
    [bundleKey.blade_seb_400psp]: {
        us: `https://us.ecoflow.com${productsName.blade_rlm}?variant=40521235464265`,
        ca: `https://ca.ecoflow.com${productsName.blade_rlm}?variant=43510266200218`,
        eu: `https://eu.ecoflow.com${productsName.blade_rlm}?variant=46491585249623`,
        uk: `https://uk.ecoflow.com${productsName.blade_rlm}?variant=46526037655891`,
        de: `https://de.ecoflow.com${productsName.blade_rlm}?variant=46538133963087`,
        fr: `https://fr.ecoflow.com${productsName.blade_rlm}?variant=46505479962971`,
        it: `https://it.ecoflow.com${productsName.blade_rlm}?variant=46532250599773`,
        es: `https://es.ecoflow.com${productsName.blade_rlm}?variant=46505471344987`,
    },
    [bundleKey.glacierriver2pro]: {
        us: `https://us.ecoflow.com${productsName.glacier_prr2pps}?variant=40524579340361`,
        ca: `https://ca.ecoflow.com${productsName.glacier_prr2pps}?variant=43507760824474`,
        eu: `https://eu.ecoflow.com${productsName.glacier_prr2pps}?variant=46491286536535`,
        uk: `https://uk.ecoflow.com${productsName.glacier_prr2pps}?variant=46525837869395`,
        de: `https://de.ecoflow.com${productsName.glacier_prr2pps}?variant=46543532556623`,
        fr: `https://fr.ecoflow.com${productsName.glacier_prr2pps}?variant=46505478521179`,
        it: `https://it.ecoflow.com${productsName.glacier_prr2pps}?variant=46505478553947`,
        es: `https://es.ecoflow.com${productsName.glacier_prr2pps}?variant=46508043207003`,
        jp: '/river-2-portable-power-station',
        cn: '/river-2-portable-power-station',
        au: 'https://au.ecoflow.com/products/glacier-river-2-pro',
        br: 'https://br.ecoflow.com/products/river-2-pro-portable-power-station?variant=49859454206248',
    },
    [bundleKey.glacierriver2max]: {
        au: 'https://au.ecoflow.com/products/glacier-river-2-max',
        us: 'https://us.ecoflow.com/products/glacier-river-2-max',
    },
    [bundleKey.wave2glacier]: {
        au: 'https://au.ecoflow.com/products/wave-2-glacier',
        us: 'https://us.ecoflow.com/products/wave-2-glacier',
    },
    [bundleKey.glacierdeltamax]: {
        us: `https://us.ecoflow.com${productsName.glacier_prdmpps}?variant=40524579864649`,
        ca: `https://ca.ecoflow.com${productsName.glacier_prdmpps}?variant=43507760890010`,
        eu: `https://eu.ecoflow.com${productsName.glacier_prdmpps}`,
        uk: `https://uk.ecoflow.com${productsName.glacier_prdmpps}`,
        de: `https://de.ecoflow.com${productsName.glacier_prdmpps}`,
        fr: `https://fr.ecoflow.com${productsName.glacier_prdmpps}`,
        it: `https://it.ecoflow.com${productsName.glacier_prdmpps}`,
        es: `https://es.ecoflow.com${productsName.glacier_prdmpps}`,
        jp: '/delta-2-portable-power-station',
        cn: '/delta-2-portable-power-station',
    },
    [bundleKey.glacierriversolar]: {
        us: `https://us.ecoflow.com${productsName.glacier_prr2pps}?variant=40524579373129`,
        ca: `https://ca.ecoflow.com${productsName.glacier_prr2pps}?variant=43507760857242`,
        eu: `https://eu.ecoflow.com${productsName.glacier_prr2pps}?variant=46491286569303`,
        uk: `https://uk.ecoflow.com${productsName.glacier_prr2pps}?variant=46525837902163`,
        de: `https://de.ecoflow.com${productsName.glacier_prr2pps}?variant=46543532589391`,
        fr: `https://fr.ecoflow.com${productsName.glacier_prr2pps}?variant=46505478553947`,
        it: `https://it.ecoflow.com${productsName.glacier_prr2pps}?variant=46535522484573`,
        es: `https://es.ecoflow.com${productsName.glacier_prr2pps}?variant=46508043239771`,
        jp: '/delta-max-portable-power-station',
        cn: '/delta-max-portable-power-station',
        au: 'https://au.ecoflow.com/products/glacier-river-2-pro',
    },
    [bundleKey.wave2delta2]: {
        us: `https://us.ecoflow.com${productsName.wave2_pacd2pps}`,
        ca: `https://ca.ecoflow.com${productsName.wave2_pacd2pps}`,
        eu: `https://eu.ecoflow.com${productsName.wave2_pacd2pps}`,
        uk: `https://uk.ecoflow.com${productsName.wave2_pacd2pps}`,
        de: `https://de.ecoflow.com${productsName.wave2_pacd2pps}`,
        fr: `https://fr.ecoflow.com${productsName.wave2_pacd2pps}`,
        it: `https://it.ecoflow.com${productsName.wave2_pacd2pps}`,
        es: `https://es.ecoflow.com${productsName.wave2_pacd2pps}`,
        jp: '/delta-2-portable-power-station',
        cn: '/river-2-portable-power-station',
    },
    [bundleKey.wave2deltamax]: {
        us: `https://us.ecoflow.com${productsName.wave2_pacdmpps}`,
        ca: `https://ca.ecoflow.com${productsName.wave2_pacdmpps}`,
        eu: `https://eu.ecoflow.com${productsName.wave2_pacdmpps}`,
        uk: `https://uk.ecoflow.com${productsName.wave2_pacdmpps}`,
        de: `https://de.ecoflow.com${productsName.wave2_pacdmpps}`,
        fr: `https://fr.ecoflow.com${productsName.wave2_pacdmpps}`,
        it: `https://it.ecoflow.com${productsName.wave2_pacdmpps}`,
        es: `https://es.ecoflow.com${productsName.wave2_pacdmpps}`,
        jp: '/delta-max-portable-power-station',
        cn: '/delta-2-portable-power-station',
        au: `https://au.ecoflow.com/products/wave-2-delta-max`,
    },
    [bundleKey.wave2deltapro]: {
        us: `https://us.ecoflow.com${productsName.wave2_pacdppps}`,
        ca: `https://ca.ecoflow.com${productsName.wave2_pacdppps}`,
        eu: `https://eu.ecoflow.com${productsName.wave2_pacdppps}`,
        uk: `https://uk.ecoflow.com${productsName.wave2_pacdppps}`,
        de: `https://de.ecoflow.com${productsName.wave2_pacdppps}`,
        fr: `https://fr.ecoflow.com${productsName.wave2_pacdppps}`,
        it: `https://it.ecoflow.com${productsName.wave2_pacdppps}`,
        es: `https://es.ecoflow.com${productsName.wave2_pacdppps}`,
        jp: '/delta-pro-portable-power-station',
        cn: '/220w-bifacial-solar-panel',
        au: `https://au.ecoflow.com/products/wave-2-delta-pro`,
    },
    [bundleKey.glacierEB]: {
        kr: `https://kr.ecoflow.com${productsName.glacierEB}?variant=43039330402473`,
        us: `https://kr.ecoflow.com${productsName.glacierEB}?variant=43039330402473`,
    },
    [bundleKey.glacierEB110w]: {
        kr: `https://kr.ecoflow.com${productsName.glacierEB110w}?variant=43040873316521`,
        us: `https://kr.ecoflow.com${productsName.glacierEB110w}?variant=43040873316521`,
    },
    [bundleKey.wave2EB]: {
        kr: `https://kr.ecoflow.com${productsName.wave2EB}?variant=43039193989289`,
        us: `https://kr.ecoflow.com${productsName.wave2EB}?variant=43039193989289`,
    },
    [bundleKey.wave2EB160w]: {
        kr: `https://kr.ecoflow.com${productsName.wave2EB160w}?variant=43040883343529`,
        us: `https://kr.ecoflow.com${productsName.wave2EB160w}?variant=43040883343529`,
    },
    // DELTA 2 Max
    [bundleKey.d2m220]: {
        us: 'https://us.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        ca: 'https://ca.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        jp: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station-220w-solar-panel',
        eu: 'https://eu.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        uk: 'https://uk.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        de: 'https://de.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        fr: 'https://fr.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        it: 'https://it.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        es: 'https://es.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        nl: 'https://nl.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
        au: 'https://au.ecoflow.com/products/delta-2-max-solar-generator-pv220w',
        ph: 'https://ph.ecoflow.com/products/delta-2-max-220w-portable-solar-panel',
    },
    [bundleKey.d2m400]: {
        us: 'https://us.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        ca: 'https://ca.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        jp: 'https://jp.ecoflow.com/products/delta-2-max-portable-power-station-400w-solar-panel',
        eu: 'https://eu.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        uk: 'https://uk.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        de: 'https://de.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        fr: 'https://fr.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        it: 'https://it.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        es: 'https://es.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        nl: 'https://nl.ecoflow.com/products/delta-2-max-400w-portable-solar-panel',
        ph: 'https://ph.ecoflow.com/products/delta-2-max-portable-power-station?variant=51451626717494',
    },
    [bundleKey.d2mPS]: {
        ph: 'https://ph.ecoflow.com/products/powerstream-microinverter?variant=51195166622006',
    },
    [bundleKey.d2mWave2]: {
        us: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner-delta-2-max-portable-power-station',
        ca: 'https://ca.ecoflow.com/products/wave-2-portable-air-conditioner-delta-2-max-portable-power-station',
        jp: 'https://jp.ecoflow.com/products/delta-2-max-wave-2-portable-air-conditioner-bundle',
    },
    [bundleKey.d2mWave2_au]: {
        au: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
    },
    [bundleKey.d2mEB]: {
        eu: 'https://eu.ecoflow.com/products/delta-2-max-smart-extra-battery-bundle',
        uk: 'https://uk.ecoflow.com/products/delta-2-max-smart-extra-battery-bundle',
        de: 'https://de.ecoflow.com/products/delta-2-max-smart-extra-battery-bundle',
        fr: 'https://fr.ecoflow.com/products/delta-2-max-smart-extra-battery-bundle',
        it: 'https://it.ecoflow.com/products/delta-2-max-smart-extra-battery-bundle',
        es: 'https://es.ecoflow.com/products/delta-2-max-smart-extra-battery-bundle',
        nl: 'https://nl.ecoflow.com/products/delta-2-max-smart-extra-battery-bundle',
        jp: 'https://jp.ecoflow.com/products/delta-2-max-extra-battery-bundle',
    },
    [bundleKey.d2mEC]: {
        au: 'https://au.ecoflow.com/products/delta-2-max-portable-power-station',
    },
    [bundleKey.r2110]: {
        br: 'https://br.ecoflow.com/products/river-2-110w-portable-solar-panel',
    },
    [bundleKey.d2220]: {
        br: 'https://br.ecoflow.com/products/delta-2-220w-portable-solar-panel',
    },
    [bundleKey.dp400]: {
        br: 'https://br.ecoflow.com/products/delta-pro-400w-portable-solar-panel',
    },
};
